const filterToggleButton = document.querySelector('.data-facets-vertical-toggle-button');
const filters = document.querySelector('#main-collection-filters');
filterToggleButton.addEventListener('click', () => {
    const button = filterToggleButton;
    const productGrid = document.querySelector('#product-grid');
    if (button.classList.contains('active')) {
        button.classList.remove('active');
        document.body.classList.add('filter-is-hidden');
        filters.style.display = 'none';
        // Replace grid--3-col-desktop with grid--4-col-desktop
        if (productGrid.classList.contains('grid--3-col-desktop')) {
            productGrid.classList.replace('grid--3-col-desktop', 'grid--4-col-desktop');
        }
    } else {
        button.classList.add('active');
        document.body.classList.remove('filter-is-hidden');
        filters.style.display = 'block';
        // Replace grid--4-col-desktop with grid--3-col-desktop
        if (productGrid.classList.contains('grid--4-col-desktop')) {
            productGrid.classList.replace('grid--4-col-desktop', 'grid--3-col-desktop');
        }
    }
});

const filterToggleButtonMobile = document.querySelector('.data-facets-vertical-toggle-mobile-button');
const filtersDrawerButton = document.querySelector('.mobile-facets__wrapper summary.mobile-facets__open-wrapper');
filterToggleButtonMobile.addEventListener('click', () => {
  filtersDrawerButton.click();
});